module.exports = __webpack_public_path__ + "img/jifen-logo.88fbd239.png";